import { Directive, Input, TemplateRef } from '@angular/core';

// Supplies a custom body/footer template for one configured column.
@Directive({
  selector: '[appTableColumn]',
  standalone: false,
})
export class TableColumnDirective {
  @Input('appTableColumn') columnKey!: string;
  constructor(public readonly template: TemplateRef<unknown>) {}
}
